import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Home from './pages/Home';
import SearchPage from './pages/SearchPage';
import PokemonDetail from './pages/PokemonDetail';
import CalendarPage from './pages/CalendarPage';
import EventDetailPage from './pages/EventDetailPage';
import GoBattleLeague from './components/GoBattleLeague';
import AdminPage from './pages/AdminPage';
import AdminLogin from './pages/AdminLogin';
import { LanguageProvider } from './contexts/LanguageContext';
import { initializeImageMap } from './utils/pokemonImageResolver';
import { initializeGameI18n } from './utils/gameI18n';

function App() {
  useEffect(() => {
    initializeImageMap().catch(err => {
      console.error('Failed to initialize Pokemon image map:', err);
    });
    initializeGameI18n().catch(err => {
      console.error('Failed to initialize game i18n:', err);
    });
  }, []);

  return (
    <LanguageProvider>
      <Router>
        <div className="min-h-screen bg-gray-50">
          <Header />
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<Home />} />
              <Route path="/search" element={<SearchPage />} />
              <Route path="/pokemon/:id" element={<PokemonDetail />} />
              <Route path="/calendar" element={<CalendarPage />} />
              <Route path="/events/:id" element={<EventDetailPage />} />
              
              {/* Go Battle League Routes */}
              <Route path="/gbl" element={<GoBattleLeague />} />
              
              {/* Admin Routes */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin/*" element={<AdminPage />} />
            </Routes>
        </div>
      </Router>
    </LanguageProvider>
  );
}

export default App;